import {
  Parallax,
  ParallaxBanner,
  ParallaxProvider,
} from "react-scroll-parallax";

import "./FullWidthBanner.scss";

const FullWidthBanner = () => {
  return (
    <div className="parallax-full-banner">
      <ParallaxProvider>
        <ParallaxBanner
          layers={[
            {
              image:
                "https://images.unsplash.com/photo-1608501821300-4f99e58bba77?q=80&w=3000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
              speed: -10,
            },
          ]}
          className="aspect-[2/1] FullWidthBanner"
        >
          <Parallax
            layers={[
              {
                children: <div />,
                speed: 40,
                scale: [1, 1.2],
                opacity: [0.9, 1],
              },
            ]}
            className="FullWidthBanner__description"
          >
            Eager to be a part of an exceptional projects, companies that values growth and
            innovation.
          </Parallax>
        </ParallaxBanner>
      </ParallaxProvider>
    </div>
  );
};

export default FullWidthBanner;
